<template>
  <md-card>
    <md-card-header>
      <div class="md-layout">
        <div class="md-layout-item md-size-90">
          <h4 class="title">Notes</h4>
          <p v-if="description" class="category">{{ description }}</p>
        </div>
        <div class="md-layout-item md-size-10 text-right">
          <md-button
            class="md-icon-button md-dense md-primary md-round"
            @click.prevent="addNote"
          >
            <md-icon>add</md-icon>
            <md-tooltip md-direction="top">Add a Note</md-tooltip>
          </md-button>
        </div>
      </div>
    </md-card-header>
    <md-card-content>
      <notes-list
        :notes="notes"
        @editNote="editNote"
        @deleteNote="deleteNote"
      />
      <notes-dialog
        :showNotesDialog.sync="showDialog"
        :note="note"
        @saveNote="saveNote"
      />
    </md-card-content>
  </md-card>
</template>

<script>
import noteApi from "@/services/api/note";
import confirm from "@/helpers/deleteConfirm";
import _filter from "lodash/filter";

import NotesList from "./NotesList.vue";
import NotesDialog from "./NotesDialog.vue";

export default {
  name: "Notes",

  props: {
    description: {
      type: String,
      default: null
    },
    notableEntity: {
      type: Object,
      default: null
    }
  },

  components: {
    NotesList,
    NotesDialog
  },

  methods: {
    getNotes() {
      if (this.notableEntity.entityId) {
        noteApi.getNotes(this.notableEntity).then(resp => {
          this.notes = resp.data;
        });
      } else {
        this.notes = [];
      }
    },

    addNote() {
      this.note = this.defaultNote();
      this.showDialog = true;
    },

    editNote(note) {
      this.note = note;
      this.showDialog = true;
    },

    saveNote(note) {
      this.showDialog = false;
      noteApi.saveNote({ ...note, ...this.notableEntity }).then(resp => {
        if (!this.notes.some(n => n.id === note.id)) {
          this.notes.unshift(resp.data);
        }
        this.note = this.defaultNote();
      });
    },

    deleteNote(note) {
      confirm.delete(null).then(resp => {
        if (resp.value) {
          noteApi.deleteNote(note).then(() => {
            this.notes = _filter(this.notes, function(n) {
              return n.id !== note.id;
            });

            this.$notify({
              timeout: 2500,
              message: "Deleted!",
              icon: "cancel",
              horizontalAlign: "center",
              verticalAlign: "top",
              type: "danger"
            });
          });
        }
      });
    },

    defaultNote() {
      return {
        content: null,
        id: null
      };
    }
  },

  data() {
    return {
      notes: [],
      showDialog: false,
      note: {
        content: null,
        id: null
      }
    };
  },

  watch: {
    notableEntity() {
      this.getNotes();
    }
  },

  created() {
    this.getNotes();
  }
};
</script>

<style lang="scss"></style>
